module.exports = __webpack_public_path__ + "img/3.204f9a18.jpg";